import { Link } from 'gatsby';
import React, { Component } from 'react'
import styled from 'styled-components'

import PropTypes from 'prop-types'

import downArrow from '../images/down-arrow.svg'
import * as functions from '../style/functions'
import leftBrace from "../images/left-brace.svg"
import rightBrace from "../images/right-brace.svg"
import * as vars from '../style/vars'

class Film extends Component {
  constructor() {
    super();
    this.state = {
      sortedSlides: [],
      totalSlides: 0,
      currentSlide: 0,
      position: 0,
      isVideoPlaying: false
    };
  }

  togglePlayFilm = () => {
    const playing = !this.state.isVideoPlaying
    this.setState({ isVideoPlaying: playing });

    let video = this.refs.video;
    if( !video ) return

    video[playing ? "pause" : "play"]();
  }

  componentDidMount() {
    let sortedSlides = this.props.slides.slice()
    sortedSlides.unshift(sortedSlides.pop())

    if( this.refs.video ) {
      this.refs.video.onended = () => {
        this.setState({ isVideoPlaying: false });
      }
    }

    this.setState({
      sortedSlides,
      totalSlides: this.props.slides.length
    });

    this.slideInterval = setInterval(() => {
      if (this.state.isVideoPlaying) {
        return;
      }

      this.setState((prevState, props) => {
        return {
          currentSlide: prevState.currentSlide+1 >= prevState.totalSlides ? 0 : prevState.currentSlide+1,
          isTransitioning: true
        }
      });

      this.resetTimeout = setTimeout(() => {
        this.setState((prevState, props) => {
          return {
            sortedSlides: [...prevState.sortedSlides.slice(1), prevState.sortedSlides[0]],
            isTransitioning: false
          }
        });
      }, this.props.delay);
    }, this.props.duration);
  }

  componentWillUnmount() {
    clearInterval(this.slideInterval);
    clearTimeout(this.resetTimeout);
  }

  render() {
    const { delay, slides, video } = this.props;

    return (
      <FilmContainer style={{ zIndex: this.state.isVideoPlaying ? 4 : null }}>
        <FilmImageContainer delay={ delay } className={ this.state.isTransitioning ? 'is-transitioning' : '' } style={{ transform: `translateX(${this.state.position }}vw)` }}>
          { this.state.sortedSlides.map(({ image, focalPoint }, index) => {
            return <FilmImage key={`film-image-${index}`} src={image} style={{ backgroundPosition: focalPoint }}></FilmImage>
          }) }
        </FilmImageContainer>

        {this.state.isVideoPlaying && ( video.youku || video.youtube || video.mp4 ) && (
          <FilmVideoContainer delay={ delay } className={ this.state.isVideoPlaying ? 'is-playing' : ''}>
            {video.youku && (
              <iframe src={`https://player.youku.com/embed/${video.youku}?autoplay=true`} frameBorder="0" title="OneSpace" allow="autoplay; encrypted-media" allowFullScreen></iframe>
            )}

            {video.youtube && ! video.youku && (
              <iframe src={`https://www.youtube.com/embed/${video.youtube}?autoplay=1&amp;rel=0&amp;showinfo=0`} frameBorder="0" title="OneSpace" allow="autoplay; encrypted-media" allowFullScreen></iframe>
            )}

            {video.mp4 && ! video.youtube && ! video.youku && (
              <video ref="video" autoPlay playsInline>
                <source src={video.mp4} type="video/mp4"/>
                <source src={video.ogg} type="video/ogg" />
                <source src={video.webm} type="video/webm" />
              </video>
            )}
          </FilmVideoContainer>
        )}

        <FilmSlideContainer>
          <FilmLogoContainer />

          <FilmSlides>
            {slides
            .map(({ title, caption, link }, index) => {
              if ( ! link || ! caption || caption === '<p></p>' ) {
                return;
              }

              const link_doc = link && link.document;
              const base     = link_doc && link_doc.data.url_base.text;
              const url      = link_doc && ((base ? `/${base}` : "") + `/${link_doc.uid}`);

              return (<FilmSlide delay={delay} key={`film-slide-${index}`} className={ this.state.currentSlide === index ? 'is-active' : '' }>
                <Link to={url}><FilmSlideTitle dangerouslySetInnerHTML={{ __html: title }} /></Link>
                <FilmSlideCaption dangerouslySetInnerHTML={{ __html: caption }} />
              </FilmSlide>)
            })}
          </FilmSlides>

          {(video.youtube || video.youku) && ! video.playFilmText && (
            <FilmPlayFilm onClick={this.togglePlayFilm}>{video.playFilmText}</FilmPlayFilm>
          )}
          <FilmScroll>
            <FilmTagLine dangerouslySetInnerHTML={{ __html: video.filmTagLine }} />
            <FilmDownLink href="#enquiry">
              <FilmDownArrow src={downArrow} alt="Scroll Down"></FilmDownArrow>
            </FilmDownLink>
          </FilmScroll>
        </FilmSlideContainer>

        <CloseButton className={this.state.isVideoPlaying ? "show" : ""} onClick={this.togglePlayFilm} />
      </FilmContainer>
    );
  }
}


const CloseButton = styled.i`
  position: absolute;
  right: 4rem;
  top: 4rem;
  width: 48px;
  height: 48px;
  z-index: 5;
  will-change: opacity;
  opacity: 0;
  transition: 1s opacity;
  transition-delay: 500ms;
  cursor: pointer;

  &.show {
    opacity: 0.5;

    :hover {
      opacity: 1;
    }
  }

  :before, :after {
    content: "";
    position: absolute;
    left: 24px;
    height: 49px;
    width: 2px;
    background: #fff;
  }

  :after {
    transform: rotate(-45deg);
  }

  :before {
    transform: rotate(45deg);
  }
`

const FilmContainer = styled.section`
  align-items: center;
  color: ${vars.colors.blank};
  display: flex;
  height: calc(100vh - 4rem);
  justify-content: center;
  overflow-x: hidden;
  position: relative;

  a {
    text-decoration: none;
  }

  // These are needed because 100vh on iOS is 100% of the screen NOT the viewport
  @supports (-webkit-overflow-scrolling: touch) {
    height: calc(100vh - 100px);

    // Landscape
    @media only screen and (orientation: landscape) {
      height: 80vw;
    }

    // iPhone 5
    @media only screen and (orientation: landscape) and (device-aspect-ratio: 40/71) {
      height: 90vw;
    }

    @media only screen
      and (min-device-width : 768px)
      and (max-device-width : 1024px)
      and (orientation : landscape)
      and (-webkit-min-device-pixel-ratio: 2) {
        height: 67vw;
    }

    // iPhone X
    @media only screen
      and (min-device-width: 375px)
      and (max-device-width: 812px)
      and (-webkit-device-pixel-ratio: 3)
      and (orientation: portrait) {
        height: calc(100vh - 140px);
    }

    // iPhone 6/7/8 Plus
    @media only screen
      and (min-device-width: 414px)
      and (max-device-width: 736px)
      and (-webkit-device-pixel-ratio: 3)
      and (orientation: portrait) {
        height: calc(100vh - 100px);
    }

    // iPad
    @media only screen
      and (min-device-width : 768px)
      and (max-device-width : 1024px)
      and (orientation : portrait)
      and (-webkit-min-device-pixel-ratio: 2) {
        height: calc(100vh - 60px);
    }
  }
`

const FilmSlideContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 2rem;
  position: absolute;
  width: 100%;
  z-index: 2;

  ${functions.above.mobile`
    padding: 2rem 2rem 3rem;
  `}
`

const FilmVideoContainer = styled.div`
  background: ${vars.colors.body};
  display: flex;
  flex-direction: row;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity ${props => props.delay}ms ${vars.easings.easeInOut};
  width: 100%;;
  will-change: opacity;
  z-index: 3;

  iframe {
    width: 100%;
    height: 100%;
  }

  &.is-playing {
    opacity: 1;
    pointer-events: auto;
  }
`

const FilmImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  position: absolute;
  will-change: transform;
  z-index: 1;

  &.is-transitioning {
    transform: translateX(-100vw);
    transition: transform ${props => props.delay}ms ${vars.easings.easeInOut};
  }
`

const FilmImage = styled.div`
  background-image: url(${props => props.src});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  display: block;
  height: 100%;
  width: 100vw;
`

const FilmLogoContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-grow: 1.7;
  justify-content: center;

  ${functions.above.mobile`
    flex-grow: 1.5;
  `}
`

const FilmSlides = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  margin-bottom: 1rem;

  ${functions.above.mobile`
    margin-bottom: 5rem;
  `}
`

const FilmSlide = styled.div`
  opacity: 0;
  padding: 0 2rem;
  position: absolute;
  transition: opacity ${props => props.delay}ms ${vars.easings.easeInOut};
  width: 100%;
  will-change: opacity;

  &.is-active {
    opacity: 1;
    z-index: 1;
  }
`

const FilmSlideTitle = styled.h1`
  font-family: ${vars.fonts.header};
  text-transform: uppercase;
  font-style: normal;
  letter-spacing: .2rem;
  padding-bottom: 0.5rem;
  text-align: center;
`

const FilmSlideCaption = styled.div`
  align-items: center;
  display: flex;
  font-size: .6rem;
  justify-content: center;
  letter-spacing: .2rem;
  line-height: 1.378;
  margin: 0 auto;
  min-height: 3.5rem;
  padding: 0 1rem;
  text-align: center;
  text-transform: uppercase;
  width: 80vw;
  position: relative;
  max-width: 32rem;

  :after {
    background-image: url(${rightBrace});
    background-position: 100% 50%;
    right: 0;
  }

  :before {
    background-image: url(${leftBrace});
    background-position: 0% 50%;
    left: 0;
  }

  :after, :before {
    content: "";
    background-size: contain;
    background-repeat: no-repeat;
    display: block;
    position: absolute;
    top: 0;
    height: 100%;
    width: 2rem;
  }

  ${functions.above.xs`
    font-size: .8rem;
  `}

  ${functions.above.mobile`
    min-height: 6rem;
    font-size: 1.1rem;
  `}

  ${functions.above.tablet`
    padding: 0 2rem;
    width: 50vw;
  `}

  ${functions.above.desktop`
    width: 40vw;
  `}

  ${functions.above.l`
    width: 25vw;
  `}
`;

const FilmPlayFilm = styled.button`
  align-self: center;
  background-color: transparent;
  border: 1px solid ${vars.colors.blank};
  color: ${vars.colors.blank};
  cursor: pointer;
  display: flex;
  flex-grow: 0;
  font-size: .8rem;
  font-weight: bold;
  letter-spacing: .2rem;
  padding: .75rem 1.5rem;
  text-transform: uppercase;
  transition: color, background-color ${vars.time}s ease;

  ${functions.above.xs`
    font-size: 1rem;
  `}

  ${functions.above.tablet`
    font-size: 1.1rem;
  `}

  &:hover {
    background-color: ${vars.colors.blank};
    color: ${vars.colors.body};
  }
`;

const FilmScroll = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-end;
`

const FilmTagLine = styled.div`
  font-size: .6rem;
  letter-spacing: .2rem;
  line-height: 1.378;
  margin-bottom: 1rem;
  text-align: center;
  text-transform: uppercase;

  ${functions.above.xs`
    font-size: .8rem;
  `}

  ${functions.above.tablet`
    font-size: 1.1rem;
  `}
`

const FilmDownArrow = styled.img`
  flex-grow: 0;
  transition: 0.3s transform;
  width: 2em;

`

const FilmDownLink = styled.a`
  padding: 1rem;
  margin-top: -1rem;

  :hover img {
    transform: translateY(10px);
  }
`

//@NOTE: please adhere to these propTypes
Film.propTypes = {
  delay: PropTypes.number.isRequired,
  duration: PropTypes.number.isRequired,

  slides: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.string.isRequired,
    title: PropTypes.string,
    caption: PropTypes.node,
  })).isRequired,

  video: PropTypes.shape({
    mp4: PropTypes.string,
    ogg: PropTypes.string,
    webm: PropTypes.string,
  }).isRequired,
}

Film.defaultProps = {
  delay: 500,
  duration: 5000,
}




export default Film
